import router from './routers'
import Config from '@/config'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import Cookies from 'js-cookie'
import { getToken } from '@/utils/auth' // getToken from cookie
import { filterRoutes } from '@/utils/permission' // getToken from cookie 
import store from '@/store'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user','/forgetpassword','/resetpassword','/privacyPolicy','/agreementsUser','/pdfPage'] // no redirect whitelist

router.beforeEach((to, from, next) => {
    // console.log('before守卫');  
    if (to.meta.title) {
        document.title = to.meta.title + ' - ' + Config.webName
    }
    NProgress.start() // start progress bar
        // next();
        // debugger
        console.log(getToken(),to.path);
    if (getToken()) {
        // 已登录且要跳转的页面是登录页
        if (to.path === '/user') {
            next({ path: `/home?${Math.random()}` })
                // NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
        } else {
            if (store.getters.menuAuth.length === 0) { // 判断当前用户是否已拉取完user_info信息 未拉去权限；判断当前跳转路由是否在路由跳转的权限名单里
                store.dispatch('GetInfo').then(res => { // 重新拉去权限;拉去成功；判断当前跳转路由是否在路由跳转的权限名单里

                    if (to.path != '/home') {
                        let checkResult = filterRoutes(to.path);
                        if (checkResult) {
                            next();
                        } else {
                            next();   //测试打开
                            // console.log('当前路由无访问权限1');
                            // next(`/home?${Math.random()}`) // 否则全部重定向到登录页
                        }
                    } else {
                        next();
                    }
                    // 动态路由，拉取菜单
                }).catch((err) => { //拉去失败；
                    store.dispatch('LogOut').then(() => {})
                })
            } else { //已经拉去权限；判断当前跳转路由是否在路由跳转的权限名单里
                // console.log(to.path);
                if (to.path != '/home') {
                    let checkResult = filterRoutes(to.path);
                    if (checkResult) {
                        next();
                        // NProgress.done()
                    } else {

                        // console.log('当前路由无访问权限2');

                        // next(`/home?${Math.random()}`) // 否则全部重定向到登录页
                        next();   //测试打开
                    }
                } else {
                    next();
                    // NProgress.done()
                }

            }
        }
    } else {
        console.log(to.path)
        /* has no token*/
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
        } else {
            next(`/user?redirect=${to.path}`) // 否则全部重定向到登录页
                // NProgress.done()
        }
    }
})


router.afterEach(() => {
    // console.log('after守卫');
    NProgress.done() // finish progress bar
})


// WEBPACK FOOTER //
// ./src/router/index.js